import React from 'react';
import { motion } from 'framer-motion';
import { Star, Coffee, BookOpen } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-73">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-74">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start" data-id="element-75">
          <div className="inline-flex items-center gap-2 bg-gold-500/20 text-gold-700 px-4 py-1.5 rounded-full text-sm font-bold mb-6 border border-gold-500/30" data-id="element-76">
            <BookOpen className="w-4 h-4" data-id="element-77" />
            GUÍA DIGITAL
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-espresso-900" data-id="element-78">
            Aprende el arte de preparar{' '}
            <span className="text-gold-600 italic" data-id="element-79">café profesional</span> desde
            tu casa en menos de una semana.
          </h1>

          <p className="text-xl md:text-2xl text-espresso-800 mb-8 font-medium" data-id="element-80">
            Más de 500 recetas
          </p>

          <div className="flex items-center gap-2 mb-8 bg-cream-200 px-4 py-2 rounded-lg" data-id="element-81">
            <div className="flex text-gold-500" data-id="element-82">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-83" />)}
            </div>
            <span className="font-bold text-espresso-900" data-id="element-84">4.8/5</span>
            <span className="text-espresso-700 text-sm" data-id="element-85">(+2,000 lectores)</span>
          </div>

          <a href="https://elartedelcafe.online/cart/add?id=57377971798341&quantity=1" className="w-full sm:w-auto bg-cta-600 hover:bg-cta-800 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-center flex items-center justify-center gap-2" data-id="element-86">
            <span className="text-2xl" data-id="element-87">🟢</span> Agregar al carrito
          </a>

          <p className="mt-4 text-sm text-espresso-700 flex items-center gap-2" data-id="element-88">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-89"></span>
            Acceso inmediato tras la compra
          </p>
        </motion.div>

        {/* Image Placeholder */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-90">
          <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform -rotate-6 scale-105" data-id="element-91"></div>
          <div className="relative bg-gradient-to-br from-cream-200 to-espresso-800/10 border border-espresso-900/10 rounded-2xl shadow-2xl aspect-[4/5] max-w-md mx-auto flex flex-col items-center justify-center p-8 text-center overflow-hidden group" data-id="element-92">
            <div className="absolute top-0 left-0 w-full h-2 bg-gold-500" data-id="element-93"></div>
            <div className="absolute -right-12 -top-12 w-40 h-40 bg-cream-100 rounded-full opacity-50 blur-2xl" data-id="element-94"></div>

            <Coffee className="w-24 h-24 text-espresso-800 mb-6 transform group-hover:scale-110 transition-transform duration-500" strokeWidth={1.5} data-id="element-95" />
            <h3 className="font-serif text-3xl font-bold text-espresso-900 mb-2" data-id="element-96">
              El Arte del Café
            </h3>
            <p className="text-espresso-700 font-medium tracking-widest uppercase text-sm" data-id="element-97">
              Edición Digital
            </p>

            <div className="absolute bottom-0 left-0 w-full bg-espresso-900 text-cream-100 py-3 text-sm font-medium" data-id="element-98">
              +500 Recetas Exclusivas
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}